export default {
    book: 'Rezervēt {product}',
    age_limit: 'Tikai caur {age}',
    change_plan: "Mainīt plānu",
    upgrade_product: 'Atjaunināt produktu',
    upgrade: "Jaunināt",
    cancel_upgrade: "Atcelt jaunināšanu",
    choose_product: 'Izvēlieties {product}',
    days: '{count} diena | {count} dienas',
    login_register: "Pieteikties/Reģistrēties",
    current: "Pašreizējais",
    keyless_benefits: {
        label: 'Taisni uz automašīnu {0}',
        highlight: 'nomas pakalpojums™',
        list: {
            cant_lose_the_key: 'Pilna apdrošināšana',
            zero_excess: 'Nulles pārpalikums',
            phone_as_a_key: 'Tālrunis kā atslēga',
            straight_to_car: 'Nav jāgaida',
            no_queues: 'Nav rindu',
            online_id_check: 'Tiešsaistes ID pārbaude',
            self_checkout: 'Pašapkalpošanās',
        },
    },
}
